// Verified from the existing production Supabase schema during reconstruction.
// Keep this client contract aligned with production. Do not use it as a migration script.

export const TABLES = {
  additionalCoachInvites: 'additional_coach_invites',
  auditEvents: 'audit_events',
  bodyMeasurements: 'body_measurements',
  coachGroupMembers: 'coach_group_members',
  coachGroups: 'coach_groups',
  coachInvites: 'coach_invites',
  coachNotes: 'coach_notes',
  coachProposals: 'coach_proposals',
  coachRelationships: 'coach_relationships',
  exercises: 'exercises',
  planShares: 'plan_shares',
  planVersions: 'plan_versions',
  planWeekOverrides: 'plan_week_overrides',
  plans: 'plans',
  profiles: 'profiles',
  templateFolders: 'template_folders',
  workoutSessions: 'workout_sessions',
  workoutSets: 'workout_sets',
} as const

export type ProductionTable = (typeof TABLES)[keyof typeof TABLES]
export type AuthUserId = string
